import { html } from "lit";

export const ProductDetailTabHeader = ({
    headline = "",
    description = "",
}) => html`
    <!-- BEGIN Tab Header -->
    <div class="ux-t-container ux-u-mb-fluid-m">
        <div class="ux-row ux-u-flex-jc-center">
            <div class="ux-col-12 ux-col-sm-10 ux-u-text-align--center">
                ${headline &&
                html`<h3 class="ux-text-title ux-text-title--light">
                    ${headline}
                </h3>`}
                ${description &&
                html`<p class="ux-text-normal ux-text-normal--light-gray">
                    ${description}
                </p>`}
            </div>
        </div>
    </div>
    <!-- END Tab Header -->
`;

interface ProductPartSize {
    size: string;
    number: string;
}

export interface ProductPartType {
    title: string;
    text: string;
    sizes?: ProductPartSize[];
}

export const exampleProductParts: ProductPartType[] = [
    {
        title: "Stanz- und Nibbelöl für Stahl Flasche 500 ml",
        text: `Ideal für das Bearbeiten von kleinen Teilen im ortsfesten
                Einsatz. Für TruTool TKF 2000 den Adapter 1653155 separat
                bestellen.`,
        sizes: [
            {
                size: "1 Stück",
                number: "0005079",
            },
        ],
    },
    {
        title: "Stoßstahl Hochfest (eingebaut)",
        text: `Für die Bearbeitung von Baustahl zwischen 600 - 800 N/mm2`,
        sizes: [],
    },
    {
        title: "Sechskantschraube M 10 x 20 - 10.9 DIN 933",
        text: `Für Rohr-Außenbearbeitung Ø 90 - 200 mm mit Abstreifer`,
        sizes: [
            {
                size: "1 Stück",
                number: "0017302",
            },
        ],
    },
    {
        title: "Spänebox",
        text: "Für die Bearbeitung von Aluminium zwischen 200 - 400 N/mm2",
        sizes: [
            {
                size: "1 Stück",
                number: "1264419",
            },
        ],
    },
    {
        title: "Abstreifer",
        text: "Für Schrägungswinkel zwischen 20° und 45°. Zu Sonderteil Nr. 0027798 für die Rohrbearbeitung.",
        sizes: [
            {
                size: "1 Stück",
                number: "0023242",
            },
        ],
    },
    {
        title: "Rollenhalter links",
        text: "",
        sizes: [
            {
                size: "1 Stück",
                number: "1240848",
            },
        ],
    },
    {
        title: "Gleitbuchse",
        text: "",
        sizes: [
            {
                size: "1 Stück",
                number: "1884873",
            },
        ],
    },
    {
        title: "Stanz- und Nibbelöl für Stahl",
        text: "",
        sizes: [
            {
                size: "500 ml",
                number: "0103387",
            },
        ],
    },
    {
        title: "Umbausatz 120 - 160 mm",
        text: "Umbausatz für größere Werkstückdicken von 120 - 160 mm",
        sizes: [
            {
                size: "1 Stück",
                number: "0027799",
            },
        ],
    },
    {
        title: "Hochleistungs-Stoßstahl",
        text: "Für die Bearbeitung von Baustahl zwischen 700 - 900 N/mm2",
        sizes: [
            {
                size: "2er-Set",
                number: "1264420",
            },
            {
                size: "10er-Set",
                number: "1264432",
            },
        ],
    },
    {
        title: "Umbausatz 80 - 120 mm",
        text: "Umbausatz für größere Werkstückdicken 80 - 120 mm",
        sizes: [
            {
                size: "1 Stück",
                number: "0023204",
            },
        ],
    },
    {
        title: "Umbausatz 40 - 80 mm",
        text: "Umbausatz für größere Werkstückdicken von 40 - 80 mm",
        sizes: [
            {
                size: "1 Stück",
                number: "0023203",
            },
        ],
    },
    {
        title: "Traggriff",
        text: "Ermöglicht ermüdungsfreies Arbeiten bei maximaler Beweglichkeit",
        sizes: [
            {
                size: "1 Stück",
                number: "0023210",
            },
        ],
    },
    {
        title: "Arbeitsstation TKF1500/2000",
        text: `Ideal für das Bearbeiten von kleinen Teilen im ortsfesten
                Einsatz. Für TruTool TKF 2000 muss der Adapter 1653155 separat
                bestellt werden.`,
        sizes: [
            {
                size: "1 Stück",
                number: "1343474",
            },
        ],
    },
    {
        title: "Stanz- und Nibbelöl für Aluminium",
        text: "",
        sizes: [
            {
                size: "1000 ml",
                number: "0125874",
            },
        ],
    },
    {
        title: "Koffer",
        text: "",
        sizes: [
            {
                size: "1 Stück",
                number: "0121585",
            },
        ],
    },
    {
        title: "Stoßstahl",
        text: "Für die Bearbeitung von Baustahl zwischen 300 - 500 N/mm2",
        sizes: [
            {
                size: "10er-Set",
                number: "1263029",
            },
            {
                size: "2er-Set",
                number: "1263021",
            },
        ],
    },
    {
        title: "Sonderabstreifer 55°",
        text: "Für Schrägungswinkel zwischen 20° und 55°",
        sizes: [
            {
                size: "1 Stück",
                number: "0032119",
            },
        ],
    },
    {
        title: "Ständer",
        text: "Ständer für Arbeitsstation",
        sizes: [
            {
                size: "1 Stück",
                number: "0003677",
            },
        ],
    },
];
